import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5nktagw2q1: FaireBrandEntity = {
  token: "b_5nktagw2q1",
  type: "brand",
  name: "Big Moods",
  avatarUrl:
    "https://cdn.faire.com/fastly/bdf0c9ee74f99e04fb0f1009382266a90f2b8b01e1093022c975aa9685a767ca.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a66889c2dd0556a36506c4d5ce49028083e8609f3d21e3f17192675e6c1336dd.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bdf0c9ee74f99e04fb0f1009382266a90f2b8b01e1093022c975aa9685a767ca.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a66889c2dd0556a36506c4d5ce49028083e8609f3d21e3f17192675e6c1336dd.png",
  location: "Sterling Heights, MI, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 3525,
  isTopShop: true,
  isInsider: true,
  description:
    "Big Moods offers high-quality and relatable stickers! Including mental health stickers, nature stickers, funny stickers, trending stickers, LGBT stickers, dog stickers and more! Our mission is to provide great products that make people happy and support an important cause.\n\nWe also now offer greeting cards and candles!\n\nWe partner with and financially support ActiveMinds.org, impacting Mental Health education, research, advocacy, and creating a lasting change in the way mental health is talked about and treated in society.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:00.562Z",
    importedBy: "entity-db-cli",
  },
};
